import React from 'react';

export const formSubmitMapper = (data) => ({
  id_purchase_order_aset: data.id_purchase_order_aset,
  tgl_close_purchase_order_aset: data.tgl_close_purchase_order_aset,
});
